import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  list: [],
  pageInfo: { page: 1, totalPage: 2 },
  condition: { userNo: 0, page: 1, limit: 10 },

  totalCoupon: 0
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
